import { isNil, omitBy } from 'lodash';
import config from '../config';
export var QueryGroup;
(function (QueryGroup) {
    QueryGroup["Action"] = "action";
    QueryGroup["Label"] = "label";
    QueryGroup["Value"] = "value";
    QueryGroup["Category"] = "category";
})(QueryGroup || (QueryGroup = {}));
export var QueryInterval;
(function (QueryInterval) {
    QueryInterval["Day"] = "day";
    QueryInterval["Week"] = "week";
    QueryInterval["Month"] = "month";
})(QueryInterval || (QueryInterval = {}));
export var QueryField;
(function (QueryField) {
    QueryField["Label"] = "label";
})(QueryField || (QueryField = {}));
export const queryHistogram = (query) => mapGet('/e/histogram', query);
export const queryPopular = (query) => mapGet('/e/popular', query);
export const queryUserEvents = (userEventsQuery) => mapGet('/e/user', userEventsQuery);
export const queryActiveUser = (query) => mapGet('/e/active-user', query);
export const queryUserCount = (query) => mapGet('/e/user-count', query);
export const queryDistinctIds = (distinctIdsQuery) => mapGet('/e/distinct/list', distinctIdsQuery);
export const getEventFeed = (eventFeedQuery) => mapGet('/e/feed', eventFeedQuery);
export const getEventReport = (reportQuery) => mapGet(`/report/${reportQuery.project}/${reportQuery.name}`, reportQuery);
async function mapGet(path, query) {
    const paramsString = new URLSearchParams(omitBy(query, isNil));
    const url = `${config('PANDALYTICS_URL')}${path}?${paramsString}`;
    const res = await window.fetch(url);
    return res.json();
}
export function getAllDataItemKeys(response) {
    const keys = [];
    response.columns.forEach((column) => {
        column.data.forEach((dataItem) => {
            if (keys.includes(dataItem.key))
                return;
            keys.push(dataItem.key);
        });
    });
    return keys;
}
